import type { PointerEvent as ReactPointerEvent } from 'react';

/**
 * Follows a sideways drag from a handle's pointer-down until release (image and column resizers).
 * - Captures the pointer, so the drag keeps tracking outside the handle.
 * - `onMove` gets the distance from the start; `onEnd` runs once on release or cancel.
 */
export const trackHorizontalDrag = (event: ReactPointerEvent<HTMLElement>, onMove: (deltaX: number) => void, onEnd: () => void) => {
  event.preventDefault();
  event.stopPropagation();

  const handle = event.currentTarget;
  handle.setPointerCapture(event.pointerId);
  const startX = event.clientX;

  const move = (e: PointerEvent) => onMove(e.clientX - startX);
  const end = () => {
    handle.removeEventListener('pointermove', move);
    handle.removeEventListener('pointerup', end);
    handle.removeEventListener('pointercancel', end);
    onEnd();
  };

  handle.addEventListener('pointermove', move);
  handle.addEventListener('pointerup', end);
  handle.addEventListener('pointercancel', end);
};
